import axios from 'axios';
import Cookies from 'js-cookie';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('token')}`
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// // Response interceptor
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       // Handle unauthorized access
//       const activityId = localStorage.getItem('adminActivityId');
//       window.location.href = `/admin/${activityId}/login`;
//       Cookies.remove('adminToken');
//       localStorage.removeItem('adminActivityId');
//     }
//     return Promise.reject(error);
//   }
// );

export default api; 